import {
  EItemType,
  ItemBasic,
  ItemOption
} from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/item.interface';
import {
  EOrderStatus,
  Order
} from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { Profile } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/profile.interface';
import { Ticket } from 'mdello-client-ts/dist/src/interfaces/providers/ticket/ticket.interface';

export enum LoanType {
  ZERO = 'ZERO'
}

export enum LoanMethod {
  BNPL = 'bnpl',
  BOG_LOAN = 'bog_loan'
}

export interface Loan {
  method: LoanMethod;
  month: number;
  type: LoanType;
}

export interface OrderGroup {
  _id: string;
  createdAt: Date;
  customerId: string;
  loan?: Loan;
  projectId: string;
  status: EOrderStatus;
  totalPayment: number;
  transactionId?: string;
  type?: EItemType;
  updatedAt: Date;
}

export interface OrderGroupDetailed extends OrderGroup {
  customerProfile: Profile;
  orders: Array<OrderDetailed>;
}

export interface OrderDetailed extends Order {
  // Overridden
  _id: string;
  customerProfile: Profile;
  selectedItems: Array<OrderSelectedItemDetailed>;
  sellerProfile: Profile;
  /* Exists on "ticket" and "space" type orders */
  tickets?: Array<Ticket>;
}

export interface OrderSelectedItem {
  itemId: string;
  metadata?: OrderSelectedItemMetadata;
  price: number;
  quantity: number;
  selectedOption: ItemOption;
  userId: string;
}

export interface OrderSelectedItemMetadata {
  endDate?: Date;
  startDate?: Date;
}

export interface OrderSelectedItemDetailed extends OrderSelectedItem {
  item: ItemBasic;
}
